exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-25d6fd14]{font-size:12px;color:#909399;line-height:1.2;margin-top:4px}", ""]);

// exports
